export default __webpack_public_path__ + "static/media/100_15565.cd5bb795.jpg";